export const enum testIds {
	statusModule = 'spaceMangoLikesYou.statusModule.section',
	userTier = 'spaceMangoLikesYou.statusModule.userTier',
	clubTitle = 'spaceMangoLikesYou.statusModule.clubTitle',
	likesCount = 'spaceMangoLikesYou.statusModule.likesCount',
	historyButton = 'spaceMangoLikesYou.statusModule.historyButton',
	historyItem = 'spaceMangoLikesYou.statusModule.historyItem',
	experiencesCarouselModule = 'spaceMangoLikesYou.carouselModule.experiences',
	nonProfitsCarouselModule = 'spaceMangoLikesYou.carouselModule.nonProfits',
	experienceCard = 'spaceMangoLikesYou.carouselModule.experienceCard',
	experienceImg = 'spaceMangoLikesYou.carouselModule.experienceImg',
	experienceTitle = 'spaceMangoLikesYou.carouselModule.experienceTitle',
	experienceSubtitle = 'spaceMangoLikesYou.carouselModule.experienceSubtitle',
	experienceClaim = 'spaceMangoLikesYou.carouselModule.experienceClaim',
	nonProfitCard = 'spaceMangoLikesYou.carouselModule.nonProfitCard',
	carouselTagTier1 = 'spaceMangoLikesYou.carouselModule.tagTier1',
	carouselTagTier2 = 'spaceMangoLikesYou.carouselModule.tagTier2',
	carouselTagTier3 = 'spaceMangoLikesYou.carouselModule.tagTier3',
	detailModalContent = 'spaceMangoLikesYou.detailModalContent.section',
	experienceModal = 'spaceMangoLikesYou.experienceDetail.modal',
	experienceDetail = 'spaceMangoLikesYou.experienceDetail.section',
	experienceDetailImage = 'spaceMangoLikesYou.experienceDetail.image',
	experienceDetailName = 'spaceMangoLikesYou.experienceDetail.name',
	experienceDetailTitle = 'spaceMangoLikesYou.experienceDetail.title',
	experienceDetailStep = 'spaceMangoLikesYou.experienceDetail.step',
	experienceDetailLegal = 'spaceMangoLikesYou.experienceDetail.legal',
	experienceNonPartnerDetail = 'spaceMangoLikesYou.experienceDetail.nonPartner.section',
	experienceNonPartnerTitle = 'spaceMangoLikesYou.experienceNonPartnerDetail.title',
	experienceNonPartnerDescription = 'spaceMangoLikesYou.experienceDetail.Description',
	experienceDetailFooter = 'spaceMangoLikesYou.experienceDetailFooter.section',
	experienceDetailFooterButton = 'spaceMangoLikesYou.experienceDetailFooter.button',
	nonProfitDetail = 'spaceMangoLikesYou.nonProfitDetail.section',
	nonProfitDetailImage = 'spaceMangoLikesYou.nonProfitDetail.image',
	nonProfitDetailName = 'spaceMangoLikesYou.nonProfitDetail.name',
	nonProfitDetailTitle = 'spaceMangoLikesYou.nonProfitDetail.title',
	nonProfitDetailLegal = 'spaceMangoLikesYou.nonProfitDetail.legal',
	nonProfitDetailMoreInfoTitle = 'spaceMangoLikesYou.nonProfitDetail.title',
	nonProfitDetailMoreInfoDescription = 'spaceMangoLikesYou.nonProfitDetail.Description',
	nonProfitDetailFooter = 'spaceMangoLikesYou.nonProfitDetailFooter.section',
	nonProfitDetailFooterButton = 'spaceMangoLikesYou.nonProfitDetailFooter.button',
	nonProfitDetailFooterChip = 'spaceMangoLikesYou.nonProfitDetailFooter.chip',
	welcomeMessageModal = 'spaceMangoLikesYou.welcomeMessage.modal',
	currentAdvantagesList = 'spaceMangoLikesYou.advantages.currentAdvantagesList',
	advantage = 'spaceMangoLikesYou.advantages.advantage',
	unlockBenefits = 'club.unlockBenefits',
	unlockAdvantageTier1 = 'spaceMangoLikesYou.unlockAdvantage.tier1',
	unlockAdvantageTier2 = 'spaceMangoLikesYou.unlockAdvantage.tier2',
	unlockAdvantageTier3 = 'spaceMangoLikesYou.unlockAdvantage.tier3',
	nextAdvantagesList = 'spaceMangoLikesYou.unlockAdvantages.nextAdvantagesList',
	advantageDetail = 'spaceMangoLikesYou.advantages.advantageDetail',
	moreLikes = 'spaceMangoLikesYou.moreLikes.section',
	welcomeMessageModalContent = 'spaceMangoLikesYou.welcomeMessage.modalContent',
	welcomeMessageModalButton = 'spaceMangoLikesYou.welcomeMessage.modalFooter.button',
	blockedByLikesMessage = 'spaceMangoLikesYou.cardDetails.blockedMessage',
	helpModule = 'spaceMangoLikesYou.helpModule.section',
}
